import React from "react";
import ReactPlayer from "react-player";

const VideoPlayer = ({ videoId, startTime = 0, isMobile = false }) => {
  // videoId ve startTime'a göre YouTube URL'si
  const videoUrl = `https://www.youtube.com/watch?v=${videoId}&start=${startTime}`;

  return (
    <div className="video-container" style={{ height: "100%", width: "100%" }}>
      <ReactPlayer
        url={videoUrl}
        width="100%"
        height="100%"
        playing={true}
        controls={true}
        config={{
          youtube: {
            playerVars: {
              start: startTime,
              modestbranding: 1, // YouTube logosunu gizle
              rel: 0,            // İlgili videoları gösterme
              controls: 1,       // Kontroller açık
              fs: 1,             // Tam ekran butonu açık
              cc_load_policy: 0, // Altyazıları kapalı başlat
              // Mobile için ek ayarlar
              playsinline: isMobile ? 1 : 0, // iOS'ta inline oynatma
              iv_load_policy: 3, // Annotations kapalı
            },
          },
        }}
        onReady={() => console.log("Player hazır")}
        onPlay={() => console.log("Oynatılıyor")}
        onPause={() => console.log("Duraklatıldı")}
        onEnded={() => console.log("Video bitti")}
        onError={(e) => console.log("Hata oluştu:", e)}
        // Mobile için responsive ayarlar
        style={{
          minHeight: isMobile ? "200px" : "100%"
        }}
      />
    </div>
  );
};

export default VideoPlayer;